import { createSlice } from '@reduxjs/toolkit';
import { getBuilderFormApi } from '../server/forms';

const initialBuilderFormState = {
    form: null,
}

const builderFormSlice = createSlice({
    name: 'builderForm',
    initialState: initialBuilderFormState,
    reducers: {
        updateForm(state, actions) {
            state.form = actions.payload;
        },
        addPage(state, actions) {
            state.form.pages.push(actions.payload);
        },
        updatePreviw(state, actions) {
            state.form.preview = actions.payload;
        },
        updateChildSelectedByIdex(state, actions) {
            if (state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex]) {
                state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex].selected = actions.payload.selected;
            }
        },
        updateSelectedChild(state, actions) {
            if (actions.payload.isSelecetd) {
                const child = JSON.parse(JSON.stringify(state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex]));
                state.form.selectedChild = { ...actions.payload, child: child };
            } else {
                state.form.selectedChild = { ...actions.payload, child: null };
            }
        },
        setCounter(state, actions) {
            state.form.counter = actions.payload;
        },
        updatePages(state, actions) {
            state.form.pages = actions.payload;
        },
        updateRequestedFiles(state, actions) {
            state.form.requestedFiles = actions.payload;
        },
        updateChildIsFocusByIdex(state, actions) {
            if (state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex]) {
                state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex].isFocus = actions.payload.isFocus;
            }
        },
        updateChildDeletedByIdex(state, actions) {
            if (state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex]) {
                state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex].deleted = actions.payload.deleted;
            }
        },
        updateChildByIdex(state, actions) {
            state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex] = actions.payload.updatedChild;
        },
        updatePageByIdex(state, actions) {
            state.form.pages[actions.payload.pageIndex] = actions.payload.updatedPage;
        },
        updateChildInputValueByIndex(state, actions) {
            if (state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex]) {
                state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex].input.value = actions.payload.value;
            }
        },
        updateRichTextEditorStyle(state, actions) {
            state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex].richTextEditor.styles[actions.payload.styleSelector] = actions.payload.styleValue;
        },
        updateRichTextEditorNodes(state, actions) {
            state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex].richTextEditor.nodes = actions.payload.nodes;
        },
        updateChildTextareaValueByIndex(state, actions) {
            if (state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex]) {
                state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex].textarea.value = actions.payload.value;
            }
        },
        updateSelectedChildData(state, actions) {
            if (state.form.selectedChild.child) {
                state.form.selectedChild.child = actions.payload;
            }
        },
        updateChildInputCheckedByIndex(state, actions) {
            if (state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex]) {
                state.form.pages[actions.payload.pageIndex].childrens[actions.payload.childIndex].input.checked = actions.payload.checked;
            }
        },
        updateParticipant(state, actions) {
            state.form.participants = actions.payload;
        },
    }
})

export const builderFormActions = builderFormSlice.actions;
export default builderFormSlice;

export const fetchBuilderForm = (formId) => {
    return async (dispatch) => {
        try {
            const res = await getBuilderFormApi(formId);
            let data = null;
            if (res.data) {
                data = res.data;
            } else {
                data = null;
            }
            dispatch(builderFormActions.updateForm(data));
        } catch (err) {
            console.log('catch error: ', err);
        }
    }
}